import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-country-screen';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function RegisterCountry() {
  const navigate = useNavigate();

  const allowedCountries = [
    'United States',
    'United Kingdom',
    'Albania',
    // 'Antigua & Bermuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Bahamas',
    'Bahrain',
    'Belgium',
    'Benin',
    'Bosnia & Herzegovina',
    'Botswana',
    'Bulgaria',
    'Croatia',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Gibraltar',
    'Greece',
    'Hungary',
    'India',
    'Ireland',
    'Italy',
    'Latvia',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Mexico',
    'Netherlands',
    'Norway',
    'Poland',
    'Portugal',
    'Romania',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Sweden',
    'Switzerland',
  ];

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      country: '',
      currency: '',
      country_code: '',
    },
    validate: {
      country: (value) => (value ? null : FORM_ERRORS.COUNTRY_REQUIRED),
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    localStorage.setItem('ffm_register_currency', values.currency);
    localStorage.setItem('ffm_register_country', values.country_code);
    navigate(LINKS.REGISTER_PHONE);
  };

  return <Screen form={form} handleSubmit={handleSubmit} isLoading={isLoading} allowedCountries={allowedCountries} />;
}

export default RegisterCountry;
